import { render, staticRenderFns } from "./ChildrensTrust.vue?vue&type=template&id=3de8785d&scoped=true"
import script from "./ChildrensTrust.vue?vue&type=script&lang=js"
export * from "./ChildrensTrust.vue?vue&type=script&lang=js"
import style0 from "./ChildrensTrust.vue?vue&type=style&index=0&id=3de8785d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de8785d",
  null
  
)

export default component.exports